import classNames from "classnames";
import { Controller } from "react-hook-form";
import RadioCheckboxAnswers from "./radio-checkbox-answers";

const CustomCheckbox = ({
  value,
  question,
  control,
  isInline,
  isSelected,
  isDirty,
  readOnlyMode,
  required,
  errorMsg,
  attachments,
  name,
}) => {
  const handleChange = (e, controlledOnChange) => {
    const answerId = e.currentTarget?.id?.split("-")?.[1];
    controlledOnChange(value?.includes(answerId) ? [] : [answerId]);
  };

  const handleClick = (e, controlledOnChange) => {
    const answerId = e.currentTarget?.id?.split("-")?.[1];
    if (value?.includes(answerId)) {
      handleChange(e, controlledOnChange);
    }
  };

  return (
    <div className={classNames(`form__checkbox`, isInline && `form__checkbox--inline`)}>
      {question.answers?.map((answer, i) => (
        <div
          className={classNames(
            `form__checkbox-wrapper`,
            isInline && `form__checkbox-wrapper--border`,
            isInline && isSelected(answer) && `form__checkbox-wrapper--selected`
          )}
          key={answer.id}
        >
          <Controller
            name={name}
            control={control}
            rules={{ required: { value: required, message: errorMsg } }}
            render={({ field: { onChange: controlledOnChange, checked, ...others } }) => (
              <>
                <input
                  {...others}
                  type="radio"
                  className={classNames(
                    `form__input form__input--checkbox`,
                    isDirty && "form__input--dirty"
                  )}
                  id={`${name}-${answer.id}`}
                  onChange={(e) => handleChange(e, controlledOnChange)}
                  onClick={(e) => handleClick(e, controlledOnChange)}
                  value={`${answer.id}`}
                  checked={value?.includes(`${answer.id}`) || false}
                  disabled={readOnlyMode}
                />
                <RadioCheckboxAnswers
                  type="checkbox"
                  name={name}
                  required={required}
                  answer={answer}
                  attachments={attachments}
                />
              </>
            )}
          />
        </div>
      ))}
    </div>
  );
};

export default CustomCheckbox;
